import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import PaymentNotification from '../SharedComponents/PaymentNotification';
import {paymentAction, paymentType} from '../Constants/debtPaymentEnum';
import WarningMessage from '../SharedComponents/WarningMessage';
import {useDebtPaymentResult} from '../hooks/useDebtPaymentResult';
import {formatAmount} from '../utils/banTypeClassifier';
import {isMobile} from 'react-device-detect';
import {selectPaymentAmount} from '../DebtAndUpdatePaymentBlockSlice';
import {dwhBanReport, dwhCreditCardPageReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';
import ContactUsAction from 'app/Components/Shared/ContactUs/ContactUsAction';
import {contactUsEnergyMob, stepEnum} from '../Constants/debtPaymentEnum';
import {createReportIdfNewPlanSignupSelectedPackage} from 'app/utilities/reports/createReport';
import Image from 'app/Components/Shared/Image/image';

const DebtPaymentSuccess = ({onclick, goToLobby}) => {
  const {paymentData, selectedBanData, paymentActionType, hasOtherBansWithDebt, selectedPaymentType, actions} = useDebtPaymentResult();
  const loginData = useSelector((state) => state.authentication.loginData);
  const paymentAmount = useSelector(selectPaymentAmount);
  const bansForUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);
  const yDaysCount = useSelector((state) => state.debtAndUpdatePayment.paymentStatusDisplayDaysY);
  const yDaysCountEnergy = useSelector((state) => state.debtAndUpdatePayment.energyPaymentStatusDisplayDaysY);
  const [showWarningMessageDebt, setShowWarningMessageDebt] = useState(false);
  const [warningMessageDebt, setWarningMessageDebt] = useState('');

  const getCCReportData = () => ({
    banData: selectedBanData,
    loginData,
    paymentAmount,
    paymentActionType,
    bansForUpdate,
    yDaysCount,
    yDaysCountEnergy,
  });

  useEffect(() => {
    // transaction result report
    if (selectedPaymentType === paymentType.BIT) {
      dwhBanReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        actionType: DwhActionType.BitPaymentDetailsPage,
        messageText: DWHMessageText.Success,
        status: DWHStatus.Completed,
        yDaysCount,
        yDaysCountEnergy,
      });
    } else if (paymentActionType === paymentAction.PAYMENT_AND_UPDATE) {
      if (paymentData.updatePaymentSuccess === true) {
        dwhCreditCardPageReport({
          ...getCCReportData(),
          messageText: DWHMessageText.Success,
          status: DWHStatus.Completed,
          actionType: DwhActionType.PaymentAndUpdateTransaction,
        });
      } else {
        if (paymentData.returnMessage === 'IsDebit') {
          dwhCreditCardPageReport({
            ...getCCReportData(),
            messageText: DWHMessageText.SuccessPaymentOnlyUpdateNotPossible,
            status: DWHStatus.Completed,
            actionType: DwhActionType.PaymentAndUpdateTransaction,
          });
        } else {
          dwhCreditCardPageReport({
            ...getCCReportData(),
            messageText: DWHMessageText.SuccessPaymentOnlyUpdateFailed,
            status: DWHStatus.Completed,
            actionType: DwhActionType.PaymentAndUpdateTransaction,
          });
        }
      }
    } else {
      dwhCreditCardPageReport({
        ...getCCReportData(),
        messageText: DWHMessageText.Success,
        status: DWHStatus.Completed,
        actionType: DwhActionType.PaymentOnlyTransaction,
      });
    }

    // Row 26 — update payment link shown (if applicable)
    const updateLinkVisible =
      (paymentActionType === paymentAction.PAYMENT_AND_UPDATE && !paymentData.updatePaymentSuccess) ||
      (selectedBanData.hasPaymentMethodIssue && paymentActionType === paymentAction.PAYMENT);
    if (updateLinkVisible) {
      dwhCreditCardPageReport({
        ...getCCReportData(),
        actionType: DwhActionType.PaymentDetailsUpdateLink,
        messageText: DWHMessageText.PaymentDetailsUpdateLinkDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  useEffect(() => {
    actions.clearHistory();
    const remainingPayment = getRemainingPayment();

    let msg = '';
    if (remainingPayment > 0 && selectedBanData.hasDebt) {
      if (selectedBanData.paused) {
        msg = `<div> תישאר יתרת חוב בסך: <span class="amount red bold">₪${formatAmount(remainingPayment)}</span></div>`;
        msg += `<div>כדי להפעיל מחדש את החשבון, יש לשלם את כל החוב</div>`;
      } else {
        msg = `<div>נותרה יתרת חוב בסך: <span class="amount red bold">₪${formatAmount(remainingPayment)}</span></div>`;
      }
    } else if (
      selectedBanData.hasDebt &&
      paymentData.hasCellular &&
      (!selectedBanData.hasPaymentMethodIssue ||
        (paymentActionType == paymentAction.PAYMENT_AND_UPDATE && paymentData.updatePaymentSuccess))
    ) {
      msg = '<div>כדי לשחרר את קו הסלולר - <br /> יש לכבות ולהדליק את הנייד שלך</div>';
    }

    if (msg) {
      setWarningMessageDebt(msg);
      setShowWarningMessageDebt(true);
    }
  }, []);

  function getRemainingPayment() {
    return parseFloat(((parseFloat(selectedBanData?.amount) || 0) - (parseFloat(paymentData?.Amount) || 0)).toFixed(2));
  }

  const handleNavigateToUpdatePayment = () => {
    dwhCreditCardPageReport({
      ...getCCReportData(),
      actionType: DwhActionType.PaymentDetailsUpdateLink,
      messageText: DWHMessageText.PaymentDetailsUpdateLinkClicked,
      status: DWHStatus.Ongoing,
    });
  };

  function successTitle() {
    if (paymentActionType == paymentAction.PAYMENT_AND_UPDATE) {
      if (paymentData.updatePaymentSuccess) {
        return `התשלום בוצע בהצלחה <br /> ופרטי האשראי עודכנו`;
      } else {
        return `התשלום בוצע בהצלחה,<br /> אך עדכון אמצעי התשלום לא הצליח`;
      }
    } else {
      return `התשלום בוצע בהצלחה!`;
    }
  }

  function showTVWarning() {
    return (
      paymentData.tvNotification &&
      (!selectedBanData.hasPaymentMethodIssue ||
        (paymentActionType == paymentAction.PAYMENT_AND_UPDATE && paymentData.updatePaymentSuccess))
    );
  }
  function showInternetNotification() {
    return (
      getRemainingPayment() <= 0 &&
      paymentData.hasInternet &&
      (!selectedBanData.hasPaymentMethodIssue ||
        (paymentActionType == paymentAction.PAYMENT_AND_UPDATE && paymentData.updatePaymentSuccess))
    );
  }

  function getWaringPaymentIssueMessage() {
    const contactUsData = contactUsEnergyMob;
    let message;
    if (paymentData.returnMessage === 'IsDebit') {
      message = `הכרטיס שהוזן לא יכול להיות מוגדר כאמצעי<br />  תשלום קבוע, יש לנסות להגדיר כרטיס אחר`;
    } else if (!isMobile && selectedBanData.isEnergy) {
      message = `<div> נא להגדיר אמצעי תשלום קבוע,<br /> כדי להימנע מחובות נוספים בעתיד</div>`;
    } else {
      if (selectedBanData.paused) {
        message = `<div> כדי לבטל את החסימה בחשבונך - <br /> יש להגדיר אמצעי תשלום קבוע</div>`;
      } else {
        message = `<div>  מומלץ להגדיר אמצעי תשלום קבוע - <br />כדי להימנע מחובות נוספים בעתיד</div>`;
      }
    }

    return (
      <WarningMessage message={message}>
        {!selectedBanData.isEnergy ? (
          <BtnSubmit text='להגדרת אמצעי תשלום קבוע' onclick={onclick} />
        ) : (
          <ContactUsAction contentData={contactUsData} />
        )}
      </WarningMessage>
    );
  }

  return (
    <div className='debtpayment-step payment-success-step'>
      <div className='payment-success-step__icon'>
        {paymentActionType == paymentAction.PAYMENT_AND_UPDATE && !paymentData.updatePaymentSuccess ? (
          <Image src={require('../images/error.svg')} alt='payment-error' />
        ) : (
          <Image src={require('../images/success.svg')} alt='payment-success' />
        )}
      </div>

      <div className={`extra ${isMobile ? 'm-title' : 'l-title'}`} dangerouslySetInnerHTML={{__html: successTitle()}} />
      {paymentActionType == paymentAction.PAYMENT_AND_UPDATE && !paymentData.updatePaymentSuccess && (
        <div className={`update_payment-warning-top ${selectedBanData.isEnergy ? 'energy' : ''}`}>
          {getWaringPaymentIssueMessage()}
          <div className='debtpayment-notification-title'>אישור התשלום</div>
        </div>
      )}
      <div
        className={`debtpayment-notification-container ${
          paymentActionType == paymentAction.PAYMENT_AND_UPDATE && !paymentData.updatePaymentSuccess ? 'top-warning-exists' : ''
        }`}>
        <PaymentNotification paymentData={paymentData} />
      </div>

      {showTVWarning() && (
        <div className='tv-warning'>
          <WarningMessage message={`<div>כדי לחדש את הצפייה ${window.Config.brand_Name_HE} TV, יש לכבות <br /> ולהדליק את הממיר</div>`}></WarningMessage>
        </div>
      )}
      {showWarningMessageDebt && (
        <div className='debt-warning'>
          <WarningMessage message={warningMessageDebt}></WarningMessage>
        </div>
      )}
      {showInternetNotification() && (
        <div className='debt-warning'>
          <WarningMessage message={`כדי לשחרר את חסימת האינטרנט - <br /> יש לכבות ולהדליק את הנתב`}></WarningMessage>
        </div>
      )}
      {selectedBanData.hasPaymentMethodIssue && paymentActionType == paymentAction.PAYMENT && (
        <div className={`update_payment-warning ${selectedBanData.isEnergy ? 'energy' : ''}`}>{getWaringPaymentIssueMessage()}</div>
      )}
      <div className='continue-button'>
        {hasOtherBansWithDebt ? (
          <>
            <BtnSubmit text='לתשלום חוב נוסף' onclick={onclick} />
            <div type='button' className='btn-link' onClick={onclick}>
              סיום
            </div>
          </>
        ) : (
          <BtnWhiteBlackBorderBigSize text={'סיום'} onclick={onclick} />
        )}
      </div>
    </div>
  );
};

export default DebtPaymentSuccess;
